import { Bloc } from "@kernel/frontend-react-app";
import { LoaderState, MainState, defaultMainState } from "./MainState";
import { MainBloc } from "./MainBloc";

export type AppLoaderState = Pick<MainState, "loader">;

export const defaultAppLoaderState: AppLoaderState = {
  loader: defaultMainState.loader
};

export class AppLoaderBloc extends Bloc<AppLoaderState> {
  private constructor(private mainBloc: MainBloc) {
    super(defaultAppLoaderState);
  }

  public start(title: string) {
    const loader: LoaderState = {
      loading: true,
      title
    };
    this.changeState({
      ...this.state,
      loader: this.state.loader.push(loader).clone()
    });
  }

  public stop() {
    this.state.loader.pop();
    this.changeState({ ...this.state, loader: this.state.loader.clone() });
  }

  public static create(parent: MainBloc) {
    const bloc = new AppLoaderBloc(parent);
    bloc.subscribe((state: AppLoaderState) => {
      parent.changeState({
        ...parent.state,
        loader: state.loader
      });
    });
    return bloc;
  }
}
